package com.xtream.ui.tv.presentation.tvchannels

 
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AspectRatio
import androidx.compose.material.icons.filled.BookmarkAdded
import androidx.compose.material.icons.filled.Menu
import androidx.compose.material.icons.outlined.BookmarkAdd
import androidx.compose.material.icons.rounded.BrokenImage
import androidx.compose.material.icons.rounded.Tv
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import coil3.compose.ConstraintsSizeResolver
import coil3.compose.rememberAsyncImagePainter
import coil3.compose.rememberConstraintsSizeResolver
import com.xtream.composeapp.presentation.widget.EqualizerLottie
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.add_to_favorites
import com.xtream.sharedResources.resources.menu
import com.xtream.sharedResources.resources.remove_from_favorites
import com.xtream.sharedResources.resources.tv_channels
import com.xtream.sharedResources.resources.video_player_resize_mode_titles
import com.xtream.ui.ui.widget.FocusPositioner
import com.xtream.ui.ui.widget.TvButton
import com.xtream.ui.ui.widget.TvToolTipSupportButton
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringArrayResource
import org.jetbrains.compose.resources.stringResource

enum class PanelState {
    PlayerOnly,
    PlayerWithController,
    WithChannels,
    WithCategories
}
/*TODO
@Composable
fun EqualizerLottie() {
    val composition by rememberLottieComposition(
        LottieCompositionSpec.Asset("animations/equalizer.json")
    )

    // This state handles the actual "playback" logic
    val progress by animateLottieCompositionAsState(
        composition = composition,
        iterations = LottieConstants.IterateForever
    )

    val color = MaterialTheme.colorScheme.primary
    LottieAnimation(
        composition = composition,
        dynamicProperties = rememberLottieDynamicProperties(
            rememberLottieDynamicProperty(
                property = LottieProperty.COLOR_FILTER,
                value = SimpleColorFilter(color.toArgb()),
                keyPath = arrayOf("**") // The "**" targets all layers
            )),
        progress = { progress }, // Provide the animated progress here
        modifier = Modifier.size(24.dp)
    )
}*/
/*
@Preview(showBackground = true, widthDp = 520, backgroundColor = 0xFF000000)
@Composable
fun ListItemPreview() {
    ComposeUITheme() {


        Column (Modifier.padding(horizontal = 24.dp, vertical = 48.dp)) {
            TvListItem(
                headline = "Rudaw FHD",
                leadingPainter =  rememberAsyncImagePainter("https://photos.smugmug.com/Rudaw-logo/i-7WVWZvk/0/KpP92MzbzGV2SX3ftc2J6RdbjN27V7GGc6hhgG2FZ/L/unnamed-L.png")
            ,
                trailingContent = {
                    EqualizerLottie()
                },
                leadingPainterSize = 48.dp,
                onClick = {

                }
            )
            TvListItem(
                headline = "Rudaw FHD",
                leadingPainter =  rememberAsyncImagePainter("https://photos.smugmug.com/Rudaw-logo/i-7WVWZvk/0/KpP92MzbzGV2SX3ftc2J6RdbjN27V7GGc6hhgG2FZ/L/unnamed-L.png")
                ,
                trailingContent = {
                    EqualizerLottie()
                },
                leadingPainterSize = 48.dp,
                onClick = {

                }
            )
        }
    }
}
*/



@Composable
fun TvChannelInfo(
    streamControlViewModel: StreamControlViewModel,
    appSettingsViewModel: AppSettingsViewModel,
    modifier: Modifier = Modifier,
    streamState: LiveStream?,
    isFavorite: Boolean,
    onMenuControlClicked: () -> Unit = {},
    requestFocusOnShow: Boolean=false
){
  val focusRequester = remember { FocusRequester() }
  val scope = rememberCoroutineScope()

  val aspectRatio by appSettingsViewModel.videoScalingModeFlow.collectAsStateWithLifecycle(null)


  LaunchedEffect(requestFocusOnShow) {
      if(requestFocusOnShow)
          focusRequester.requestFocus()
  }
  @OptIn(ExperimentalMaterial3Api::class)

  CenterAlignedTopAppBar(
      modifier= modifier
          //.wrapContentHeight()
          .background(
              MaterialTheme.colorScheme.background.copy(alpha = .8f),
              /* brush = Brush.verticalGradient(
                                  colors = listOf(
                                      Color.Transparent,
                                      MaterialTheme.colorScheme.background.copy(alpha = .6f),
                                      MaterialTheme.colorScheme.background.copy(alpha = .8f),
                                      MaterialTheme.colorScheme.background
                                  )
                              )*/
          )
          .padding(horizontal = 48.dp, vertical = 20.dp),
      colors = TopAppBarDefaults.topAppBarColors(
          containerColor = Color.Transparent
      ),
      navigationIcon = {
          Image(
              painter = rememberAsyncImagePainter(model = streamState?.streamIcon),
              contentDescription = streamState?.name,
              contentScale = ContentScale.Crop,
              modifier = Modifier
                  .clip(CircleShape)
                  .height(48.dp)
                  .aspectRatio(1f)
          )
      },
      actions = {
          TvToolTipSupportButton(
              modifier = Modifier.focusRequester(focusRequester),
              icon =  Icons.Filled.Menu ,
              plainTooltipText = stringResource(Res.string.menu),
              onClick = {
                  onMenuControlClicked()
              }
          )

          Spacer( modifier = Modifier.width(8.dp))
          TvToolTipSupportButton(

              icon =   if (isFavorite) Icons.Filled.BookmarkAdded else Icons.Outlined.BookmarkAdd ,
              plainTooltipText = stringResource(if(isFavorite) Res.string.remove_from_favorites else Res.string.add_to_favorites),
              onClick = {
                  streamControlViewModel.updateFavoriteStatus(streamState)
              }
          )
          Spacer( modifier = Modifier.width(8.dp))
          TvToolTipSupportButton(

              icon =    Icons.Filled.AspectRatio  ,
              plainTooltipText = stringArrayResource( Res.array.video_player_resize_mode_titles)[aspectRatio?:0],
              onClick = {
                  scope.launch {

                     //TODO activity.updateVideoScalingMode()
                  }

              }
          )


      },
      title = {
          Box(
              modifier = Modifier


                  //.fillMaxSize()
              , // fills the full height of the TopAppBar
              contentAlignment = Alignment.Center // centers the Text both vertically and horizontally
          ) {
              Text(
                  modifier = Modifier
                      .fillMaxWidth()
                      .padding(horizontal = 16.dp),
                  textAlign = TextAlign.Start,
                  text = streamState?.name?.let {
                      "${streamControlViewModel.selectedPosition.value.inc()} | $it"
                  } ?: "",
                  style = MaterialTheme.typography.titleLarge
              )}
      }
  )
}




